import React from "react";
import { PiBuildingOffice } from "react-icons/pi";
import { MdAddCall } from "react-icons/md";
const Warning = () => {
  return (
    <div className="">
      {/* <div className="w-full bg-green-800 text-white py-1 px-4">
      <div className="max-w-7xl md:text-sm text-[7px] mx-auto flex flex-row md:flex-row justify-between items-center space-y-1 md:space-y-0">
        <div className="flex items-center space-x-1">
          <PiBuildingOffice className="mx-2 font-medium size-6"/>
          <span>
           MZ 01 B Zone Business Spaces, Nipaniya Square  INDORE MADHYA PRADESH,452010
          </span>
        </div>
        <div className="flex items-center space-x-1">
          <MdAddCall className="mx-2 font-medium size-6"/>
          <span>+91 9891904233</span>
        </div>
      </div>
    </div> */}
    {/* warnig */}
      <div className="w-full bg-gradient-to-br from-orange-700 to-orange-500 shadow-2xl overflow-hidden h-auto pb-3 flex items-center justify-center">
      <div className="inline-block text-center whitespace-nowrap animate-scroll text-white text-lg m-0 p-0 font-amiriQuran ">
        Investment/Trading in Securities Market is subject to market risk. Readsm:text-ba
        all the related documents carefully before investing. Please read the
        document of our privacy policy, terms of use & disclaimer on our
        website. We do not provide any guaranteed or assured return services,
        profit sharing services, Demat Account services, Investment related
        services, or any other services which are not mentioned on our website.
      </div>
    </div>
    </div>
  );
};

export default Warning;
